import fp from "lodash/fp";
import { IRequestAction, progressEpic } from "epics/base-epic";
import { VARIANTS } from "constants/action-types";
import siteConfig from "site-config";
import { IVariantsMap } from "reducers/variants";
import { IProductVariant } from "records/item/item";

export const fetchVariants = progressEpic<IRequestAction, IVariantsMap>(
    VARIANTS.FETCH,
    ({ payload }) => ({ method: "GET", url: siteConfig.api + payload.url }),
    {
        dataCustomizer: (response, action, store) => ({
            ...store.variants.payload,
            ...fp.compose(
                fp.mapValues(
                    (value: { __variants: IProductVariant[] }) => fp.find({ key: "color" }, value?.__variants)?.items
                ),
                fp.keyBy("_id")
            )(response),
        }),
        mapper: "mergeMap",
    }
);
